import {AcquisitionStatus} from '../../_types/selectOptionsTypes/AcquisitionStatusType';

export const acquisitionStatusOptions: Array<AcquisitionStatus> = [
  {value: 'UNSET', label: 'Unset'},
  {value: 'PROSPECTIVE', label: 'Prospective'},
  {value: 'UNDER_CONTRACT', label: 'Under contract'},
  {value: 'OWNED', label: 'Owned'},
];
